import { twMerge } from "tailwind-merge";

import { CDN_UPLOAD_URL } from "@config";

interface UploadImageProps {
  name: string;
  className?: string;
  children?: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

export default function UploadImage({ name, className, children, onClick }: UploadImageProps) {
  return (
    <div
      style={{ backgroundImage: `url(${CDN_UPLOAD_URL}/upload/${name})` }}
      className={twMerge("bg-center bg-cover bg-no-repeat shrink-0", className)}
      onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        onClick?.(e);
      }}
    >
      {children}
    </div>
  );
}
